// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8ec38386","977":"96b36285"}[chunkId] + ".chunk.js";
};